import { render, staticRenderFns } from "./premiumInfo.vue?vue&type=template&id=c9941888&scoped=true&"
import script from "./premiumInfo.vue?vue&type=script&lang=js&"
export * from "./premiumInfo.vue?vue&type=script&lang=js&"
import style0 from "./premiumInfo.vue?vue&type=style&index=0&id=c9941888&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9941888",
  null
  
)

export default component.exports